import MoneyKit, { type LinkExitError } from '@moneykit/connect';

type LaunchResult = {
  exchangeableToken: string | null;
  type: 'success' | 'exit';
};

export const launchMoneyKit = ({
  linkSessionToken,
  isExistingLink,
}: {
  linkSessionToken: string;
  isExistingLink: boolean;
}): Promise<LaunchResult> => {
  const moneykit = new MoneyKit({
    colorScheme: 'light',
  });

  return new Promise((resolve, reject) => {
    const handleExit = (exitError: LinkExitError | null) => {
      if (exitError) {
        reject(new Error(exitError.displayed_message));
      } else {
        resolve({ exchangeableToken: null, type: 'exit' });
      }
    };

    if (isExistingLink) {
      moneykit.relink(
        linkSessionToken,
        () => {
          resolve({ exchangeableToken: null, type: 'success' });
        },
        handleExit,
      );
    } else {
      moneykit.link(
        linkSessionToken,
        exchangeableToken => {
          resolve({ exchangeableToken, type: 'success' });
        },
        handleExit,
      );
    }
  });
};
